<template>
    <div>
        <div class="flex justify-center">
            <vs-card class="w-10/12 mt-5 shadow-lg card relative">
                <form ref="form" @submit.prevent="validate" class="flex flex-col items-center">
                    <div class="w-10/12 mt-10">
                        <h2 class="mb-4">Success</h2>
                        <h3 class="mb-4">
                            Thanks for redeeming the Coupon, you can now access content in the app
                        </h3>
                    </div>

                    <app-links />

                    <img
                        src="@/assets/images/croc.png"
                        height="250"
                        alt="Croc Image"
                        class="croc"
                    />
                </form>
            </vs-card>
        </div>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'
import AppLinks from '../register/AppLinks.vue'

export default {
    name: 'coupon-success',
    computed: {},
    watch: {},
    components: { AppLinks },
    data() {
        return {}
    },
    methods: {
        validate() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                }
            })
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
}
#logo {
    background-color: #b7dcc9;
}

.card {
    border-radius: 30px;
    min-height: 400px;
    max-width: 650px;
}
.customPadding {
    padding: 8px;
}
.customPadding2 {
    padding: 10px;
}
@media only screen and (min-height: 1200px) {
    .card {
        height: 800px;
    }
    .height {
        height: 1202px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
